import { useJsApiLoader } from '@react-google-maps/api';
import envConfig from '../../../../envConfig';

// Hoisted module-level constant so the reference is stable across renders.
// @react-google-maps/api compares this by reference; an inline array would
// trigger reload warnings and can cause duplicate script injection.
const LIBRARIES = ['marker'];

// A single, shared loader id ensures the Maps JS script is injected exactly
// once for the whole app, no matter how many maps are mounted. Every extra
// script load is a billable "Map Load", so this directly controls cost.
export default function useGoogleMapsLoader() {
  return useJsApiLoader({
    id: 'adn-google-maps-script',
    googleMapsApiKey: envConfig.googleMapsApiKey,
    libraries: LIBRARIES,
  });
}
